import React, { useState, useEffect } from 'react';
import {
	Button,
	Grid,
	Dialog,
	DialogTitle,
	DialogContent,
	Table,
	TableHead,
	TableRow,
	TableCell,
	TableBody,
	CircularProgress,
	DialogActions,
	Typography,
} from '@mui/material';
import Sidebar from '../components/Sidebar';
import axios from 'axios';

function CustomerReport() {
	const [open, setOpen] = useState(false);
	const [inactiveCustomers, setInactiveCustomers] = useState([]);
	const [loading, setLoading] = useState(false);
	const [totalCustomers, setTotalCustomers] = useState(0);

	const handleOpenModal = async () => {
		setOpen(true);
		setLoading(true);
		try {
			const response = await axios.get('https://rockmanapi.nexlogssolutions.com/api/inactive-customers/');
			// const response = await axios.get('http://127.0.0.1:8000/api/inactive-customers/');
			setInactiveCustomers(response.data);
		} catch (error) {
			console.error('Failed to fetch inactive customers:', error);
		} finally {
			setLoading(false);
		}
	};

	const handleCloseModal = () => {
		setOpen(false);
	};

	useEffect(() => {
		const fetchTotalCustomers = async () => {
			try {
				const response = await axios.get('https://rockmanapi.nexlogssolutions.com/api/total-customers/');
				// const response = await axios.get('http://127.0.0.1:8000/api/total-customers/');
				setTotalCustomers(response.data.total_customers);
			} catch (error) {
				console.error('Failed to fetch total customer count:', error);
			}
		};

		fetchTotalCustomers();
	}, []);

	return (
		<Grid container>
			<Grid id="sidebarContainer" item md={2}>
				<Sidebar />
			</Grid>
			<Grid item container md={10} sx={{ px: 5, my: 5 }}>
				<Grid item xs={12} md={6}>
					<Typography variant="h6" gutterBottom>
						Total Number Of Customers: {totalCustomers}
					</Typography>
					<Button
						fullWidth
						variant="contained"
						onClick={handleOpenModal}
						sx={{ textTransform: 'capitalize' }}
					>
						Inactive Customers (Last 2 Months)
					</Button>
				</Grid>
			</Grid>

			{/* Modal */}
			<Dialog open={open} onClose={handleCloseModal} maxWidth="md" fullWidth>
				<DialogTitle>Inactive Customers {loading ? '' : `(${inactiveCustomers.length})`}</DialogTitle>
				<DialogContent>
					{loading ? (
						<Grid container justifyContent="center" alignItems="center" sx={{ py: 5 }}>
							<CircularProgress />
						</Grid>
					) : inactiveCustomers.length === 0 ? (
						<p>No inactive customers found in the last 2 months.</p>
					) : (
						<Table>
							<TableHead>
								<TableRow>
									<TableCell>
										<strong>Username</strong>
									</TableCell>
									<TableCell>
										<strong>Phone Number</strong>
									</TableCell>
									<TableCell>
										<strong>Transfer Balance ($)</strong>
									</TableCell>
									<TableCell>
										<strong>Freight Balance ($)</strong>
									</TableCell>
									<TableCell>
										<strong>Last Activity Date</strong>
									</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{inactiveCustomers.map((customer) => (
									<TableRow key={customer.id}>
										<TableCell>{customer.username}</TableCell>
										<TableCell>{customer.phone_no}</TableCell>
										<TableCell>${customer.tranfer_account_balance}</TableCell>
										<TableCell>${customer.freight_account_balance}</TableCell>
										<TableCell>{customer.last_activity_date || 'N/A'}</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					)}
				</DialogContent>
				<DialogActions>
					<Button onClick={handleCloseModal}>Close</Button>
				</DialogActions>
			</Dialog>
		</Grid>
	);
}

export default CustomerReport;
